module.exports = __webpack_public_path__ + "static/assets/aec82df1815f19f4e5729fa7b992dfd4.png";